import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { APIService } from '../../services/api.service';
import { JobService } from '../../services/job.service.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SitemapComponent } from 'src/app/shared/sitemap/sitemap.component';

@Component({
  selector: 'app-job-header',
  templateUrl: './app-job-header.component.html',
  styleUrls: ['./app-job-header.component.scss'],
  standalone: false,
})
export class JobHeaderComponent implements OnInit {
  eventData: any = [];
  canShare = false;

  constructor(
    public api: APIService,
    public jobService: JobService,
    private router: Router,
    private title: Title,
    private meta: Meta,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
    private deviceDetectorService: DeviceDetectorService
  ) {}

  ngOnInit(): void {}
}
